import * as React from "react"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../api/axios";

export default function Home() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate(); 
    useEffect(() => { 
        const checkLoginStatus = async () => { 
            try {
                const response = await axios.get('/home', {
                    headers: {
                        'Accept': 'application/json',
                        'ngrok-skip-browser-warning': '1',
                    },
                    withCredentials: true,
                });
                if (response?.data?.success === "home page") {
                    setIsLoggedIn(true);
                }
                else {
                    navigate('/'); 
                }
            } catch (error) { 
                console.error('Error checking login status:', error); 
                navigate('/'); 
            }
        };
        checkLoginStatus(); 
        }, [navigate]);
    if (!isLoggedIn) { 
        return <div>Loading...</div>; 
    }
    else {
        return (
            <div>
                <h1>Home</h1>
            </div>
        )
    };
}